class EnhancedCertifications {
  constructor(section) {
    this.section = section;
    this.stats = section.querySelectorAll('.cert-stat__value');
    this.init();
  }

  init() {
    // Animate stats on scroll
    if (this.stats.length > 0) {
      this.observeStats();
    }
  }

  observeStats() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateStat(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.5
    });

    this.stats.forEach(stat => {
      observer.observe(stat);
    });
  }

  animateStat(element) {
    const target = parseInt(element.dataset.target) || 0;
    const duration = 2000;
    const increment = target / (duration / 16);
    let current = 0;

    const updateNumber = () => {
      current += increment;
      if (current < target) {
        element.textContent = Math.floor(current);
        requestAnimationFrame(updateNumber);
      } else {
        element.textContent = target;
      }
    };

    updateNumber();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.enhanced-certifications');
  sections.forEach(section => {
    new EnhancedCertifications(section);
  });
});

// Initialize on Shopify section load (theme editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('enhanced-certifications')) {
    new EnhancedCertifications(event.target);
  }
});